function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M4.14205 3L5.84659 4.70455C5.94886 4.80682 6 4.93182 6 5.07955C6 5.22727 5.94886 5.35795 5.84659 5.47159L5.47159 5.84659C5.35795 5.94886 5.22727 6 5.07955 6C4.93182 6 4.80682 5.94886 4.70455 5.84659L3 4.14205L1.29545 5.84659C1.19318 5.94886 1.06818 6 0.920455 6C0.772727 6 0.642045 5.94886 0.528409 5.84659L0.153409 5.47159C0.0511364 5.35795 0 5.22727 0 5.07955C0 4.93182 0.0511364 4.80682 0.153409 4.70455L1.85795 3L0.153409 1.29545C0.0511364 1.19318 0 1.06818 0 0.920455C0 0.772727 0.0511364 0.642045 0.153409 0.528409L0.528409 0.153409C0.642045 0.0511364 0.772727 0 0.920455 0C1.06818 0 1.19318 0.0511364 1.29545 0.153409L3 1.85795L4.70455 0.153409C4.80682 0.0511364 4.93182 0 5.07955 0C5.22727 0 5.35795 0.0511364 5.47159 0.153409L5.84659 0.528409C5.94886 0.642045 6 0.772727 6 0.920455C6 1.06818 5.94886 1.19318 5.84659 1.29545L4.14205 3Z",
  fill: "#444444"
});

var SvgClose = function SvgClose(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 6,
    viewBox: "0 0 6 6",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgClose, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/close.728ed125.svg";
export { ForwardRef as ReactComponent };